import Navbar from '../NavBar/NavBarSGI';
import Navbar2 from '../NavBar/NavBarSGI2';
import React, { useState, useEffect } from 'react';
import Conexao from '../../Config/conexao';
import axios from 'axios';
import emailjs from '@emailjs/browser';
import './AvalEfc.css';
import moment from 'moment';
import { Container, ContainerForm, TextFieldStyled } from "./styles";
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import { Row, Col, Offcanvas } from 'react-bootstrap';
import { Link, Redirect } from 'react-router-dom';


import download from "downloadjs";


import { Modal, Button } from 'react-bootstrap';

export default function Avaliacao() {

  const [acoes, setAcoes] = useState([]);
  const [verificaEficacia, setVerificaEficacia] = useState([]);


  const [item1, setItem1] = useState([]);
  const [item2, setItem2] = useState([]);
  const [item3, setItem3] = useState([]);
  const [acao1, setAcao1] = useState([]);
  const [acao2, setAcao2] = useState([]);
  const [acao3, setAcao3] = useState([]);
  const [responsavelAcao1, setResponsavelAcao1] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [previsaoAcao1, setPrevisaoAcao1] = useState([]);

  const [execucaoAcao1, setExecucaoAcao1] = useState([]);
  const [acaorealizada, setAcaorealizada] = useState([]);
  const [responsavel, setResponsavel] = useState([]);
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingItemId0, setEditingItemId0] = useState(null);
  const [editingItemId2, setEditingItemId2] = useState();
  const [editingItemId3, setEditingItemId3] = useState();
  const [editingItemIdx2, setEditingItemIdx2] = useState();
  const [editingItemIdx3, setEditingItemIdx3] = useState();
  const [newExecucaoAcao, setNewExecucaoAcao] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [setorLogado, setSetorLogado] = useState();
  const [setorDoCargo, setSetorDoCargo] = useState();

  const [filtro, setFiltro] = useState(false);

  const [abreFiltro, setAbreFiltro] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const [rnc, setRnc] = useState();
  const [AcoesFiltro, setAcoesFiltro] = useState();

  const [tudoConcluido, setTudoConcluido] = useState();

  const [abrir1, setAbrir1] = useState(false);
  const [imagem, setImagem] = useState();
  const [imagemPreview, setImagemPreview] = useState();
  const [itemSelecionado, setItemSelecionado] = useState([]);
  const [showModal1, setShowModal1] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const handleCloseSidebar = () => {
    setShowSidebar(false);
    
  }
  function carregaUser() { setSetorLogado(localStorage.usuario) };
  useEffect(() => { carregaUser() });

  async function getSetor() {
    const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
    if (res.data.success === false) {
      //  setLoading(false)
      //  falha();  
    } else {
      setSetorDoCargo(res.data.setor);
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      console.log("QUEEEEM  " + setorLogado);
    }
  };


  useEffect(() => { getSetor() }, []);





  function naoEncontrado() {
    alert('RNC não encontrado!')
  };

  const [atraso, setAtraso] = useState();

  /*    async function BuscarAcoes() {
          const res = await axios.get(Conexao.api + 'ListaRNCAcoesWEBPlano.php');
          console.log( res.data.result)
          if (res.data.success === false) {
        
            } else {
      
          setAcoes(res.data.result)
  
  
          const acoes = res.data.result;
  
          // Verificar se previsaoAcao1 é anterior ou posterior ao dia atual
          acoes.forEach((acao) => {
            if (moment(acao.previsaoAcao1).isBefore(moment(), 'day') && acao.atraso === '') { } 
            
             else {     }
          });
      
            }  
          };    */


  async function BuscarAcoes() {
    const res = await axios.get(Conexao.api + 'ListaRNCAcoesWEBPlano.php');
    console.log(res.data.result);

    if (res.data.success === false) {

    } else {
      setAcoes(res.data.result);

      acoes.forEach(async (a) => {

        if (moment(a.previsaoAcao1).isBefore(moment(), 'day') && a.atraso === 'NÃO') {
          console.log("ESTÃO VAZIOS " + a.id)
          //  setAtraso ("sim") 
          const id = a.id;
          const protocolo = a.protocolo;
          const rnc = a.protocolo
          setAtraso("SIM")
          const obj = { atraso, id, rnc };

          const resx = await axios.post(Conexao.api + 'SalvarAtrasoAcaoRNCWEB.php', obj);
          if (resx.data.success === true) {


            const setorX = ('SGI');

            const resY = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailAcoes.php?id=' + id + '&setorOrigem2=' + setorX);
            
            if (resY.data.success === false) { }
            else { }

          }

        
        }

      })

    }
  }




  const [countX, setCountX] = useState(false);
  const [exibirH6, setExibirH6] = useState(false);

  async function BuscarAcoesComFiltro() {
    const res = await axios.get(Conexao.api + 'ListaRNCAcoesWEB.php?protocolo=' + rnc);
    console.log(res.data.result)
    if (res.data.success === false) {
      naoEncontrado();

    } else {

      setAcoesFiltro(res.data.result)

      Filtrar3();


      const execucaoQuantities = res.data.result.map(item => item.execucaoAcao1).filter(Boolean).length;
      const previsaoQuantities = res.data.result.map(item => item.previsaoAcao1).filter(Boolean).length;

      if (execucaoQuantities > 0 && previsaoQuantities > 0 && execucaoQuantities === previsaoQuantities) {
        setCountX(true);
        setExibirH6(true);
        alert('Todas as ações foram concluidas!')
      } else {
        setCountX(false);
        setExibirH6(false);
      }



    }
  };



  function ClickDelete(id) {
    deleteUser(id)
    const updatedAcoes = acoes.filter((f) => f.id !== id);
    setAcoes(updatedAcoes);
  };

  async function deleteUser(id) {
    const res = await axios.get(Conexao.api + 'ExcluirAcoesRNCWEB.php?id=' + id);
    if (res.data.success === true) {
      // setConfirmacao(false);
      BuscarAcoes()
    }
  };


  useEffect(() => { BuscarAcoes() }, []);
  /* useEffect(()=>{BuscarAcoesComFiltro()}); */

  async function getSetor() {
    const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
    if (res.data.success === false) {
      //  setLoading(false)
      //  falha();  
    } else {
      setSetorDoCargo(res.data.setor);
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      console.log("QUEEEEM  " + setorLogado);
    }
  };

  useEffect(() => { getSetor() });






  const [showModal, setShowModal] = useState(false);

  const handleEditClick = (itemId, itemProtocolo) => {
    const itemToEdit = acoes.find((f) => f.id === itemId);
    const itemToEdit2 = acoes.find((f) => f.protocolo === itemProtocolo);
    setEditingItemId(itemId);
    setEditingItemId0(itemProtocolo);

    setShowModal(true);
  };


  const handleEditClick2 = (itemId2, acaoX) => {
    const itemToEdit = acoes.find((f) => f.protocolo === itemId2);
    const itemToEdit2 = acoes.find((f) => f.item1 === acaoX);
    setEditingItemId2(itemId2);
    setEditingItemId3(acaoX);




  };





  const SalvarAcoes = async () => {


    const id = editingItemId;

    const obj = { id, execucaoAcao1, acaorealizada, responsavel };

    // Enviar os dados para a API
    const res = await axios.post(Conexao.api + 'SalvarUPDATERNCAcoes.php', obj);

    if (res.data.success === true) {
      console.log('Dados salvos com sucesso na API');
      /* alert("salvooou") */
      BuscarAcoes();
      setShowModal(false);
      setExecucaoAcao1('');
      //  EnviarEmail(editingItemId0, editingItemId);
      const setorX = ('SGI');

      const res = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailAcoes.php?id=' + id + '&setorOrigem2=' + setorX);

      if (res.data.success === false) { }
      else { }
    }


  };


  function carregaUser() { setSetorLogado(localStorage.usuario) };
  useEffect(() => { carregaUser() });



  function AbrirFiltro() {
    setAbreFiltro(!abreFiltro)

  };

  function Filtrar() {
    setFiltro(!filtro)
  }

  function Filtrar2() {
    setFiltro(false)
    setTudoConcluido(false)
    setRnc('')
  }

  function Filtrar3() {
    setFiltro(true)
  }

  function Limpar() {
    setTudoConcluido(false)
  }


  function AbrirAnexo() {
    setAbrir1(!abrir1)
  }


  const handleDownloadClick = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview) {
      const link = document.createElement('a');
      link.href = imagemPreview;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };


  const handleImagemChange = (e) => {
    const file = e.target.files[0];
    setImagem(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }

  };

  const SalvarAnexoAcoes = async () => {

    const protocolo = editingItemId2;
    const item = editingItemId3;

    const obj = { protocolo, item, imagem: imagemPreview };
    // Enviar os dados para a API
    const res = await axios.post(Conexao.api + 'SalvarAnexoRNCWEB.php', obj);

    if (res.data.success === true) {
      console.log('Dados salvos com sucesso na API');
      alert("Imagem salva com sucesso!")
    }
  };

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

  }




  async function getAnexo(editingItemId2, editingItemId3) {

    /*   const itemToEdit = acoes.find((f) => f.protocolo === itemId3);
      const itemToEdit2 = acoes.find((f) => f.item1 === acaoX3);
      setEditingItemIdx2(itemId3);
      setEditingItemIdx3(acaoX3); */

    /*   const protocolo = editingItemId2;
      const item = editingItemId3; */
    const res = await axios.get(Conexao.api + 'BuscarAnexoRNCWEB.php? rnc=' + editingItemId2 + '&id=' + editingItemId3);
    if (res.data.success === false) {
      //  setLoading(false)
      //  falha();  
    } else {
      setImagem(res.data.Anexo);
      setImagemPreview(res.data.Anexo);
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      console.log("QUEEEEM  " + setorLogado);
    }
  };
  //visualizar acoes realizadas
  async function buscardadosrnc(editingItemId2, editingItemId3) {
    console.log(editingItemId2, editingItemId3);
    const res = await axios.get(Conexao.api + 'ListaRNCAcoesFilter.php?rnc=' + editingItemId2 + '&id=' + editingItemId3);
    console.log(res.data.result);

    if (res.data.success === true) {
      console.log(res.data.result);
      setItemSelecionado(res.data.result);
      setShowModalInfo(true);
    }

  }
  function LimparImg() {
    setImagem('');
    setImagemPreview('');


  };


  const [nprocesso, setNprocesso] = useState();

  const [nSetor, setNSetor] = useState();
  const [nDescricao, setNDescricao] = useState();

  async function EnviarEmail(editingItemId0, editingItemId) {

    const setorX = ('SGI');

    const res2 = await axios.get(Conexao.api + 'BuscarRNCWEB.php? protocolo=' + editingItemId0);
    // setNprocesso(res2.data.pegaProtocolo);
    setNSetor(res2.data.setorOrigem);


    const res = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailAcoes.php? nprocesso=' + editingItemId0
      + '&setorOrigem2=' + setorX + '&acao=' + editingItemId);

    if (res.data.success === false) { }
    else { }
  };


  return <div className="home">

    <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1600px', minWidth: '1600px' }} >
      {/* Botao de Menu  */}
      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Titulo */}
      <div className="sidebar-Text">
        <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%', }}>Não Conformidades</text>
      </div>
      {/* Logica da pagina */}
      <Container>
        <ContainerForm>
          {abreFiltro === false ?
            <div className="  d-flex justify-content-center  align-items-center  mt-5" >
              <button onClick={() => AbrirFiltro()} class="btnlogin ">Filtro</button>
            </div>

            : <div className="  d-flex justify-content-center  align-items-center  mt-5" >
              <button onClick={() => Filtrar2() & AbrirFiltro()} class="btnlogin ">Fechar Filtro</button>
            </div>}


          {abreFiltro === true ?
            <div className="  d-flex justify-content-center  align-items-center  mt-5" >
              <div class="col-sm-2 ms-3  ">
                <input placeholder='Digite o número da RNC' onChange={(e) => setRnc(e.target.value) & Limpar()} value={rnc} class="borda form-control  text-center "  ></input>
              </div>
              <div class="col-auto ms-2">
                <button onClick={() => BuscarAcoesComFiltro()} class="btnlogin "  >BUSCAR</button>
              </div>
            </div>
            : null}


          <body class="container-fluid text-center mt-5 cinzaclaro ">
            <div class="col  align-items-center justify-content-center p-2 ">
              <div className="row">
                <div className="col-2 text-center">
                  <h6 className='ms-2'>RNC</h6>
                </div>
                <div className="col-1 text-center">
                  <h6>N° da ação</h6>
                </div>
                <div className="col-3 text-center">
                  <h6>Descrição da ação</h6>
                </div>
                <div className="col-2 text-center">
                  <h6>Responsável pela ação</h6>
                </div>
                <div className="col-2 text-center">
                  <h6>Prazo de Avaliação</h6>
                </div>

                <div className="col-1 text-center">
                  <h6>Status</h6>
                </div>
                <div className="col-1 text-center">
                  <h6>Concluir</h6>
                </div>
              </div>
            </div>
          </body>


          {filtro === false ? (

            <body class="container-fluid text-center colorInput ">
              <div class="col  align-items-center justify-content-start p-2 colorInput">


                {acoes.map((f, i) => <div key={i} class="row d-flex align-items-center justify-content-center ">

                  {f.acao1 !== '' && f.execucaoAcao1 === "" ? <div class="row d-flex align-items-center  justify-content-center p-1 borda">

                    <div class="col-2 ">{f.protocolo}</div>
                    <div class="col-1">{f.item1} </div>
                    <div class="col-3 ">{f.acao1}</div>

                    <div class="col-2">{f.responsavelAcao1}</div>

                    <div class="col-2">{f.acao1 && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>

                    <div class="col-1 d-flex text-center align-items-center mt-1 justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill={
                          moment(f.previsaoAcao1).isBefore(moment(), 'day') ? 'red' : 'darkorange'
                        }
                        class="bi bi-circle-fill "
                        viewBox="0 0 16 16"
                      >
                        <circle cx="7" cy="7" r="7" />
                      </svg>

                      {f.acao1 &&
                        f.previsaoAcao1 &&
                        moment(f.previsaoAcao1).isBefore(moment(), 'day') ? (

                        <h6>Em atraso</h6>

                      ) : (
                        <h6>Em andamento</h6>
                      )}

                    </div>

                    <div class="col-1">
                      {f.responsavelAcao1 === setorLogado ? (
                        <button onClick={() => handleEditClick(f.id)} className="far fa-edit icone-acao green botaao"></button>
                      ) : (
                        <button disabled className="far fa-edit icone-acao blue botaao" title="Editar"></button>
                      )}

                      <button className="fas fa-paperclip  green botaao" title="Anexo" data-bs-toggle="modal" data-bs-target="#ModalAcoes" onClick={() => {
                        handleEditClick2(f.protocolo, f.item1);
                        getAnexo(f.protocolo, f.item1);
                      }} >
                      </button>


                      <button className="fas fa-solid fa-eye  green botaao" title="Visualizar" data-bs-toggle="modal" data-bs-target="#ModalAcoesReali" onClick={() => {
                        buscardadosrnc(f.protocolo, f.id);
                        // getAnexo(f.protocolo, f.item1);
                      }} >
                      </button>

                      <div class="modal" id="ModalAcoes" tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered modal-lg" >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="ModalAcoesLabel">Anexar imagem</h1>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => LimparImg()}></button>
                            </div>

                            <div class="modal-body">
                              <div class="container text-center  ">
                                <div class="col  align-items-center justify-content-center p-2 ">
                                  <div class="row d-flex align-items-center justify-content-center ">

                                    <input className='col' type="file" onChange={handleImagemChange} />

                                    {imagemPreview && (
                                      <div>
                                        <img src={imagemPreview} className='mt-3' alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                                      </div>
                                    )}


                                    {imagem && (
                                      <div>
                                        <button class="btn btn-outline-success mb-3" onClick={handleDownloadClick}>Download</button>
                                      </div>
                                    )}

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={() => LimparImg()}>Fechar</button>
                              <button type="button" class="btn btn-success" onClick={() => SalvarAnexoAcoes()} >Salvar</button>
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>

                  </div>
                    : null}

                  {/*  8888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888 */}

                  {setorDoCargo === 'SGI' && f.acao1 && f.item1 && f.execucaoAcao1 !== "" ? <div class="row d-flex align-items-center justify-content-center p-1 borda">

                    <div class="col-2 ">{f.protocolo}</div>
                    <div class="col-1">{f.item1} </div>
                    <div class="col-3 ">{f.acao1}</div>

                    <div class="col-2">{f.responsavelAcao1}</div>

                    <div class="col-2">{f.acao1 && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>


                    <div class="col-1 d-flex  align-items-center mt-1 justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill={
                          f.execucaoAcao1 !== '' && f.item1 !== "" ? 'green' : ''
                        }
                        class="bi bi-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <circle cx="7" cy="7" r="7" />
                      </svg>

                      {f.acao1 && f.execucaoAcao1 ? (

                        <h6>Concluído</h6>

                      ) : null}

                    </div>

                    <div class="col-1">
                      {f.responsavelAcao1 === setorLogado ? (
                        <button onClick={() => handleEditClick(f.id)} className="far fa-edit icone-acao green botaao"></button>
                      ) : (
                        <button disabled className="far fa-edit icone-acao blue botaao" title="Responsável divergente"></button>
                      )}

                      <button className="fas fa-paperclip  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoes" onClick={() => {
                        handleEditClick2(f.protocolo, f.item1);
                        getAnexo(f.protocolo, f.item1);
                      }} >  </button>
                      <button className="fas fa-solid fa-eye  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoesReali" onClick={() => {
                        buscardadosrnc(f.protocolo, f.id);
                        // getAnexo(f.protocolo, f.item1);
                      }} ></button>
                      <div class="modal" id="ModalAcoes" tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered modal-lg" >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="ModalAcoesLabel">Anexar imagem</h1>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => LimparImg()}></button>
                            </div>

                            <div class="modal-body">
                              <div class="container text-center  ">
                                <div class="col  align-items-center justify-content-center p-2 ">
                                  <div class="row d-flex align-items-center justify-content-center ">

                                    <input className='col' type="file" onChange={handleImagemChange} />

                                    {imagemPreview && (
                                      <div>
                                        <img src={imagemPreview} className='mt-3' alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                                      </div>
                                    )}


                                    {imagem && (
                                      <div>
                                        <button onClick={handleDownloadClick}>Download</button>
                                      </div>
                                    )}

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={() => LimparImg()}>Fechar</button>
                              <button type="button" class="btn btn-success" onClick={() => SalvarAnexoAcoes()} >Salvar</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                    : null}

                </div>)}

              </div>
            </body>

          ) :

            <body class="container-fluid text-center colorInput ">
              <div class="col  align-items-center justify-content-start p-2 colorInput">


                {AcoesFiltro.map((f, i) => <div key={i} class="row d-flex align-items-start justify-content-center ">

                  {f.acao1 !== '' && f.execucaoAcao1 === "" ? <div class="row d-flex align-items-start justify-content-center p-1 borda">

                    <div class="col-2 " >{f.protocolo}</div>
                    <div class="col-1">{f.item1} </div>
                    <div class="col-3 ">{f.acao1}</div>

                    <div class="col-2">{f.responsavelAcao1}</div>
                    <div class="col-2">{f.acao1 && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>

                    <div class="col-1 d-flex text-center align-items-center justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill={
                          moment(f.previsaoAcao1).isBefore(moment(), 'day') ? 'red' : 'darkorange'
                        }
                        class="bi bi-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <circle cx="7" cy="7" r="7" />
                      </svg>

                      {f.acao1 &&
                        f.previsaoAcao1 &&
                        moment(f.previsaoAcao1).isBefore(moment(), 'day') ? (

                        <h6>Em atraso</h6>

                      ) : (
                        <h6>Em andamento</h6>
                      )}

                    </div>

                    <div class="col-1">
                      {f.responsavelAcao1 === setorLogado ? (
                        <button onClick={() => handleEditClick(f.id)} className="far fa-edit icone-acao green botaao"></button>
                      ) : (
                        <button disabled className="far fa-edit icone-acao blue botaao" title="Responsável divergente"></button>
                      )}

                      <button className="fas fa-paperclip  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoes" onClick={() => {
                        handleEditClick2(f.protocolo, f.item1);
                        getAnexo(f.protocolo, f.item1);
                      }} >  </button>
                      <button className="fas fa-solid fa-eye  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoesReali" onClick={() => {
                        buscardadosrnc(f.protocolo, f.id);
                        // getAnexo(f.protocolo, f.item1);
                      }} ></button>
                      <div class="modal" id="ModalAcoes" tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered modal-lg" >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="ModalAcoesLabel">Anexar imagem</h1>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => LimparImg()}></button>
                            </div>

                            <div class="modal-body">
                              <div class="container text-center  ">
                                <div class="col  align-items-center justify-content-center p-2 ">
                                  <div class="row d-flex align-items-center justify-content-center ">

                                    <input className='col' type="file" onChange={handleImagemChange} />

                                    {imagemPreview && (
                                      <div>
                                        <img src={imagemPreview} className='mt-3' alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                                      </div>
                                    )}


                                    {imagem && (
                                      <div>
                                        <button onClick={handleDownloadClick}>Download</button>
                                      </div>
                                    )}

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={() => LimparImg()}>Fechar</button>
                              <button type="button" class="btn btn-success" onClick={() => SalvarAnexoAcoes()} >Salvar</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                    : null}

                  {/*  8888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888 */}

                  {/*   {setorDoCargo === 'SGI' && countX === true && exibirH6 ? <div><h4 className='texttitulo'> <strong>Todas as ações foram concluídas!</strong></h4> </div> 
    
    :null}  */}

                  {setorDoCargo === 'SGI' && f.acao1 && f.item1 && f.execucaoAcao1 !== "" && countX === false ? <div class="row d-flex align-items-start justify-content-center p-1 borda">


                    <div class="col-2 " >{f.protocolo}</div>
                    <div class="col-1">{f.item1} </div>
                    <div class="col-3 ">{f.acao1}</div>

                    <div class="col-2">{f.responsavelAcao1}</div>
                    <div class="col-2">{f.acao1 && (moment(f.previsaoAcao1).format('DD/MM/YYYY'))} </div>


                    <div class="col-1 d-flex text-center align-items-center justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill={
                          f.execucaoAcao1 !== '' && f.item1 !== "" ? 'green' : ''
                        }
                        class="bi bi-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <circle cx="7" cy="7" r="7" />
                      </svg>

                      {f.acao1 && f.execucaoAcao1 ? (

                        <h6>Concluído</h6>

                      ) : null}

                    </div>

                    <div class="col-1">
                      {f.responsavelAcao1 === setorLogado ? (
                        <button onClick={() => handleEditClick(f.id)} className="far fa-edit icone-acao green botaao"></button>
                      ) : (
                        <button disabled className="far fa-edit icone-acao blue botaao" title="Responsável divergente"></button>
                      )}

                      <button className="fas fa-paperclip  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoes" onClick={() => {
                        handleEditClick2(f.protocolo, f.item1);
                        getAnexo(f.protocolo, f.item1);
                      }} >  </button>
                      <button className="fas fa-solid fa-eye  green botaao" data-bs-toggle="modal" data-bs-target="#ModalAcoesReali" onClick={() => {
                        buscardadosrnc(f.protocolo, f.id);
                        // getAnexo(f.protocolo, f.item1);
                      }} ></button>
                      <div class="modal" id="ModalAcoes" tabindex="" aria-labelledby="ModalAcoesLabel" aria-hidden="true" >
                        <div class="modal-dialog modal-dialog-centered modal-lg" >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="ModalAcoesLabel">Anexar imagem</h1>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => LimparImg()}></button>
                            </div>

                            <div class="modal-body">
                              <div class="container text-center  ">
                                <div class="col  align-items-center justify-content-center p-2 ">
                                  <div class=" d-flex align-items-center justify-content-center ">

                                    <input className='col' type="file" onChange={handleImagemChange} />

                                    {imagemPreview && (
                                      <div>
                                        <img src={imagemPreview} className='mt-3' alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                                      </div>
                                    )}


                                    {imagem && (
                                      <div>
                                        <button onClick={handleDownloadClick}>Download</button>
                                      </div>
                                    )}

                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={() => LimparImg()}>Fechar</button>
                              <button type="button" class="btn btn-success" onClick={() => SalvarAnexoAcoes()} >Salvar</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

                    /*: setorDoCargo === 'SGI' &&  f.acao1 !== ""  && f.item1 !== "" &&  f.execucaoAcao1 !== ''    && f.previsaoAcao1 === f.execucaoAcao1*/ /* && f.previsaoAcao1.every === f.execucaoAcao1.every && f.acao1.every === f.execucaoAcao1.every f.execucaoAcao1.every!=='' && f.previsaoAcao1.every === f.execucaoAcao1.every  ? (
                      <div className='titulolaboratorio container-fluid mt-2'>
                        <h4 className='texttitulo'> <strong>Todas as ações foram concluídas!</strong></h4>
                      </div>   
                    )*/

                    : null}

                </div>)}

              </div>
            </body>

          };






          {/* Modal para acoes realaizada */}
          {/* <div class="modal" id="ModalAcoesReali" tabindex="0" aria-labelledby="ModalAcoesReali" aria-hidden="true" >
                  <div class="modal-dialog modal-dialog-centered modal-lg" >
                    <div class="modal-content">
                      <div class="modal-header">
                        <h1 class="modal-title fs-5" id="ModalAcoesReali">Informações</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => LimparImg()}></button>
                      </div>

                      <div class="modal-body">
                        <div class="container text-center  ">
                          <div class="col  align-items-center justify-content-center p-2 ">
                            
                          {itemSelecionado[0] && itemSelecionado[0].acao1}
 
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div> */}
          <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Informações {/* execucaoAcao1 - ID: {editingItemId} */}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <h6>RNC</h6>
              {itemSelecionado[0] && itemSelecionado[0].protocolo}


              <hr />
              <h6>Nº da ação</h6>
              {itemSelecionado[0] && itemSelecionado[0].item1}
              <hr />
              <h6>Descrição da Ação</h6>
              {itemSelecionado[0] && itemSelecionado[0].acao1}
              <hr />
              <h6>Responsavel pela ação</h6>
              {itemSelecionado[0] && itemSelecionado[0].responsavelAcao1}
              <hr />
              <h6>Prazo de Avaliação</h6>
              {itemSelecionado[0] && (moment(itemSelecionado[0].previsaoAcao1).format('DD/MM/YYYY'))}
              <hr />
              <h6> Ação Realizada</h6>
              {itemSelecionado[0] && itemSelecionado[0].acaorealizada}
              <hr />
              <h6> Responsável por Realizar</h6>
              {itemSelecionado[0] && itemSelecionado[0].responsavel1}


            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModalInfo(false)}>
                Fechar
              </Button>

            </Modal.Footer>
          </Modal>

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Execução {/* execucaoAcao1 - ID: {editingItemId} */}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <input type='date' placeholder='Execução' className='form-control text-center colorInput ' value={execucaoAcao1} onChange={(e) => setExecucaoAcao1(e.target.value)}></input>

              <input type='text' placeholder='Ação Realizada' className='form-control text-center colorInput ' value={acaorealizada} onChange={(e) => setAcaorealizada(e.target.value)}></input>
              <input type='text' placeholder='Responsável' className='form-control text-center colorInput ' value={responsavel} onChange={(e) => setResponsavel(e.target.value)}></input>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false) & setExecucaoAcao1('')}>
                Fechar
              </Button>
              <Button variant="btn btn-success" onClick={SalvarAcoes} >
                Salvar
              </Button>
            </Modal.Footer>
          </Modal>



        </ContainerForm>
      </Container>
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
        <div className="offcanvas-header">
          
         
          <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
        </div>
        <Offcanvas.Body>
          <ul>
            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
              <Link to="/app/SGI" style={{ textDecoration: 'none' }}>
                <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
            </li>
            {/* <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked1 ? '#00221A' : 'white', fontSize: '1.5em' }}>Sobre o Geo+ <span className="icon-right move-right1">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked1 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked2 ? 'li-slide-right' : ''} >
              <Button variant="link" style={{ textDecoration: 'none', color: 'white', fontSize: '1.5em' }}>Suporte <span className="icon-right move-right2">
                <i className="bi bi-chevron-right"></i>
              </span></Button>
            </li> */}
            {/* <li className={liClicked3 ? 'li-slide-right' : ''} onClick={() => handleLiClickGeocontrole(4)}>
              <Button variant="link" style={{ textDecoration: 'none', color: 'white',color: liClicked3 ? '#00221A' : 'white', fontSize: '1.5em' }}>Geocontrole <span className="icon-right move-right3">
                <i className="bi bi-chevron-right"style={{textDecoration: 'none',color: liClicked3 ? '#00221A' : 'white'}}></i>
              </span></Button>
            </li> */}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  </div>
}